var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c("div", {
          domProps: {
            innerHTML: _vm._s(
              _vm.getSelectedClass.VIEW_OPTIONS.CWP_INSTRUCTIONS
            )
          }
        })
      ]),
      _vm._v(" "),
      Object.keys(_vm.selectedCourse).length > 0
        ? _c(
            "div",
            { staticClass: "horizontal-tabs" },
            [
              _c(
                "tabs",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    options: {
                      useUrlFragment: false,
                      defaultTabHash: _vm.defaultTab
                    }
                  }
                },
                _vm._l(_vm.selectedCourse.MARKING_PERIODS, function(mp, m) {
                  return _c(
                    "tab",
                    {
                      key: m,
                      attrs: {
                        id: mp.MP_CODE,
                        name: mp.MP_DESC + " (" + mp.MP_CODE + ")"
                      }
                    },
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table default-table table-striped table-bordered text-center",
                            attrs: { id: "studentSchedule" }
                          },
                          [
                            _c("thead", [
                              _vm.selectedCourse.DAYS
                                ? _c(
                                    "tr",
                                    [
                                      _c("th", [
                                        _vm._v(_vm._s(_vm.periodDaysText))
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.selectedCourse.DAYS, function(
                                        label,
                                        l
                                      ) {
                                        return _c("th", { key: l }, [
                                          _vm.showDayCode && _vm.showDayDesc
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(label.DAY_DESC) +
                                                    " (" +
                                                    _vm._s(label.DAY_CODE) +
                                                    ")"
                                                )
                                              ])
                                            : _vm.showDayDesc
                                            ? _c("span", [
                                                _vm._v(_vm._s(label.DAY_DESC))
                                              ])
                                            : _vm.showDayCode
                                            ? _c("span", [
                                                _vm._v(_vm._s(label.DAY_CODE))
                                              ])
                                            : _vm._e()
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _c("tr", [
                                    _c("th", { attrs: { colspan: "6" } }, [
                                      _c("p", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.loadingMessageText))
                                        ])
                                      ])
                                    ])
                                  ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.selectedCourse.PERIODS, function(
                                period,
                                p
                              ) {
                                return _c(
                                  "tr",
                                  { key: p },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "period",
                                        attrs: { tabindex: "0" }
                                      },
                                      [
                                        _c("div", [
                                          _vm.showPeriodCode &&
                                          _vm.showPeriodDesc
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(period.PERIOD_DESC) +
                                                    " (" +
                                                    _vm._s(period.PERIOD_CODE) +
                                                    ")\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            : _vm.showPeriodDesc
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(period.PERIOD_DESC)
                                                )
                                              ])
                                            : _vm.showPeriodCode
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(period.PERIOD_CODE)
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _vm.showPeriodTimes
                                          ? _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("time")(
                                                        period.PERIOD_START_TIME
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]),
                                              _vm._v(" - "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("time")(
                                                        period.PERIOD_END_TIME
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.selectedCourse.DAYS, function(
                                      day,
                                      d
                                    ) {
                                      return _c(
                                        "td",
                                        {
                                          key: d,
                                          class: _vm.getCellStatus(
                                            mp.MP_CODE,
                                            period.PERIOD_CODE,
                                            day.DAY_CODE
                                          ),
                                          attrs: { tabindex: "0" }
                                        },
                                        [
                                          _vm.getCourse(
                                            mp.MP_CODE,
                                            period.PERIOD_CODE,
                                            day.DAY_CODE
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "course-info" },
                                                [
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "strong",
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.getCourse(
                                                                  mp.MP_CODE,
                                                                  period.PERIOD_CODE,
                                                                  day.DAY_CODE
                                                                ).COURSE_TITLE
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                          _vm.showCourseID
                                                            ? [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t(" +
                                                                    _vm._s(
                                                                      _vm.getCourse(
                                                                        mp.MP_CODE,
                                                                        period.PERIOD_CODE,
                                                                        day.DAY_CODE
                                                                      )
                                                                        .COURSE_ID
                                                                    ) +
                                                                    ")\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.getCourse(
                                                        mp.MP_CODE,
                                                        period.PERIOD_CODE,
                                                        day.DAY_CODE
                                                      ).COURSE_CATALOG_DESC
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "tooltip",
                                                                  rawName:
                                                                    "v-tooltip.top-center",
                                                                  value: {
                                                                    content: _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    )
                                                                      .COURSE_CATALOG_DESC,
                                                                    trigger:
                                                                      "hover click"
                                                                  },
                                                                  expression:
                                                                    "{content: getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_CATALOG_DESC, trigger: 'hover click'}",
                                                                  modifiers: {
                                                                    "top-center": true
                                                                  }
                                                                }
                                                              ],
                                                              attrs: {
                                                                icon:
                                                                  "info-circle"
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.isSelectedTopic(
                                                    mp.MP_CODE,
                                                    period.PERIOD_CODE,
                                                    day.DAY_CODE
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          class: _vm.getTopicsClass(
                                                            mp.MP_CODE,
                                                            period.PERIOD_CODE,
                                                            day.DAY_CODE
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "topic-head"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "clickable",
                                                                  attrs: {
                                                                    icon:
                                                                      "times"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.cancelTopic()
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    )
                                                                      .COURSE_CATALOG_DESC
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.showTeacherName
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.getCourse(
                                                                mp.MP_CODE,
                                                                period.PERIOD_CODE,
                                                                day.DAY_CODE
                                                              ).STAFF_NAME
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.showRoomCode ||
                                                  _vm.showRoomDesc
                                                    ? _c("div", [
                                                        _vm.showRoomDesc &&
                                                        _vm.showRoomCode
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\tRM: " +
                                                                  _vm._s(
                                                                    _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    ).ROOM_DESC
                                                                  ) +
                                                                  " (" +
                                                                  _vm._s(
                                                                    _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    ).ROOM_CODE
                                                                  ) +
                                                                  ")\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.showRoomCode &&
                                                        !_vm.showRoomDesc
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\tRM: " +
                                                                  _vm._s(
                                                                    _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    ).ROOM_CODE
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.showRoomCode &&
                                                        _vm.showRoomDesc
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\tRM: " +
                                                                  _vm._s(
                                                                    _vm.getCourse(
                                                                      mp.MP_CODE,
                                                                      period.PERIOD_CODE,
                                                                      day.DAY_CODE
                                                                    ).ROOM_DESC
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.showDurationCode &&
                                                  !!_vm.getCourse(
                                                    mp.MP_CODE,
                                                    period.PERIOD_CODE,
                                                    day.DAY_CODE
                                                  ).DURATION_CODE
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\tDUR: " +
                                                            _vm._s(
                                                              _vm.getCourse(
                                                                mp.MP_CODE,
                                                                period.PERIOD_CODE,
                                                                day.DAY_CODE
                                                              ).DURATION_CODE
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.getIsRemovable(
                                                    mp.MP_CODE,
                                                    period.PERIOD_CODE,
                                                    day.DAY_CODE
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drop-course"
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "clickable",
                                                              attrs: {
                                                                icon:
                                                                  "minus-circle",
                                                                size: "2x"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.confirmCourseRemoval(
                                                                    mp.MP_CODE,
                                                                    period.PERIOD_CODE,
                                                                    day.DAY_CODE
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "clickable",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showAvailableClasses(
                                                        mp.MP_CODE,
                                                        period.PERIOD_CODE,
                                                        day.DAY_CODE
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(_vm.emptyText) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.availableCourses
        ? _c(
            "modal",
            {
              attrs: {
                "modal-title": _vm.getModalTitle(),
                closeText: _vm.closeText,
                show: _vm.showModal,
                "dialog-size": "lg",
                name: "mappingsModal"
              },
              on: {
                close: function($event) {
                  return _vm.$emit("closeModal")
                }
              }
            },
            [
              [
                _vm.conflict
                  ? _c("div", { staticClass: "alert alert-warning" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.courseConflictMessage))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row filter-bar" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("label", [_vm._v(_vm._s(_vm.filterByText))]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterBy,
                            expression: "filterBy"
                          }
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.filterBy = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.allDepartmentsText))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.departments, function(dept, d) {
                          return _c(
                            "option",
                            {
                              key: d,
                              domProps: { value: dept.DEPARTMENT_CODE }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(dept.DEPARTMENT_DESC) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "toggle-buttons" },
                      [
                        _c("sapphire-toggle", {
                          attrs: {
                            value: false,
                            cssColors: true,
                            label: _vm.showUnavailableClassesText,
                            showInFront: false,
                            ariaLabel:
                              _vm.showUnavailableClassesText +
                              " " +
                              _vm.unavailableCount,
                            addedLabelClasses: "col-lg-9",
                            addedToggleClasses: "col-lg-3"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "end",
                                fn: function() {
                                  return [
                                    _c("strong", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.showUnavailableClassesText
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "badge" }, [
                                        _vm._v(_vm._s(_vm.unavailableCount))
                                      ])
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2814336597
                          ),
                          model: {
                            value: _vm.showUnavailable,
                            callback: function($$v) {
                              _vm.showUnavailable = $$v
                            },
                            expression: "showUnavailable"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "toggle-buttons" },
                      [
                        _c("sapphire-toggle", {
                          attrs: {
                            value: false,
                            cssColors: true,
                            label: _vm.showCourseDescriptionsText,
                            showInFront: false,
                            ariaLabel: _vm.showCourseDescriptionsText,
                            addedLabelClasses: "col-lg-9",
                            addedToggleClasses: "col-lg-3"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "end",
                                fn: function() {
                                  return [
                                    _c("strong", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.showCourseDescriptionsText
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1028838341
                          ),
                          model: {
                            value: _vm.showDescriptions,
                            callback: function($$v) {
                              _vm.showDescriptions = $$v
                            },
                            expression: "showDescriptions"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-default table-striped" },
                  [
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.availableCourses, function(available, a) {
                          return [
                            _vm.displayIt(available)
                              ? _c(
                                  "tr",
                                  {
                                    key: a,
                                    class: {
                                      unavailable:
                                        available.IS_CONFLICT_FLG === "Y" ||
                                        available.SEATS_AVAILABLE <= 0,
                                      clickable:
                                        available.IS_CONFLICT_FLG === "N" &&
                                        available.SEATS_AVAILABLE > 0 &&
                                        _vm.canAdd
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("addCourse", available)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "courseInfo col-sm-4" },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            class: {
                                              unavailable:
                                                available.IS_CONFLICT_FLG ===
                                                  "Y" ||
                                                available.SEATS_AVAILABLE <= 0
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(available.COURSE_TITLE) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _vm.showCourseID
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t(" +
                                                      _vm._s(
                                                        available.COURSE_ID
                                                      ) +
                                                      ")\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        available.topics
                                          ? _c("font-awesome-icon", {
                                              attrs: { icon: "info-circle" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewAvailableTopics(
                                                    available
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {}, [
                                          !!available.TEACHER_NAME &&
                                          _vm.showTeacherName
                                            ? _c("small", [
                                                _c("strong", [
                                                  _vm._v("Teacher:")
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      available.TEACHER_NAME
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (!!available.ROOM_CODE ||
                                            !!available.ROOM_DESC) &&
                                          (_vm.showRoomCode || _vm.showRoomDesc)
                                            ? _c(
                                                "small",
                                                [
                                                  _c("strong", [
                                                    _vm._v("Room: ")
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.showRoomDesc &&
                                                  !!available.ROOM_DESC
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            available.ROOM_DESC
                                                          ) + " "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.showRoomCode &&
                                                  !!available.ROOM_CODE
                                                    ? [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              available.ROOM_CODE
                                                            ) +
                                                            ")"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !!available.DURATION_CODE &&
                                          _vm.showDurationCode
                                            ? _c("small", [
                                                !!available.DURATION_CODE
                                                  ? _c("strong", [
                                                      _vm._v("Duration:")
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      available.DURATION_CODE
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        available.showTopics
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "course-topics left"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "topic-head" },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: { icon: "times" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          available.showTopics = false
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          available.course
                                                        ) + " Topics"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    available.topics,
                                                    function(topic, t) {
                                                      return _c(
                                                        "li",
                                                        { key: t },
                                                        [_vm._v(_vm._s(topic))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "col-sm-5" }, [
                                      _vm.showDescriptions
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                available.COURSE_CATALOG_DESC
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "col-sm-3 text-right" },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "condensed pull-right"
                                          },
                                          [
                                            _c("thead", [
                                              _c("th", [
                                                _vm._v("Meets period(days):")
                                              ]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("seats")])
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("td", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    available.TIMEPATTERN
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    available.SEATS_AVAILABLE
                                                  )
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": "Please Confirm",
            show: _vm.showConfirm,
            "dialog-size": "md",
            name: "confirmModal",
            closeText: _vm.closeText
          },
          on: {
            close: function($event) {
              return _vm.closeConfirm()
            }
          }
        },
        [
          _c("h4", { staticClass: "text-center" }, [
            _vm._v(
              "\n\t\t\tDo you really want to remove " +
                _vm._s(_vm.selectedCourse.COURSE_TITLE) +
                "?\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { close: _vm.closeConfirm }, slot: "footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("removeCourse", _vm.selectedMatrixCell)
                    }
                  }
                },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.confirmText) + "\n\t\t\t")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: { click: _vm.closeConfirm }
                },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.cancelText) + "\n\t\t\t")]
              )
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }